import React from 'react';
import './App.less';
import ErrorBoundary from './components/layout/ErrorBoundary/ErrorBoundary';
import Layout from './pages/Layout/Layout';

const App = () => {
  return (
    <ErrorBoundary>
      <Layout />
    </ErrorBoundary>
  );
};

export default App;
